import { Grid } from '@mui/material';
import { SlideParagraph, SlideSubtitle } from 'features/slides';
import React from 'react';
import styles from './styles.module.css';
import { ModelSetCharacteristicTable } from '../modelset-characteristic-table';
import { ModelSetCharacteristics } from 'features/premium-report/api/types';
import {
  PORTFOLIO1,
  PORTFOLIO2,
} from 'pages/Cases/hooks/usePostCalculatePortfolioCharacteristics';

export function PortfolioCharacteristics({
  portfolioCharacteristics,
  type,
}: {
  portfolioCharacteristics: ModelSetCharacteristics[];
  type: string;
}): React.ReactElement {
  const portfolioDate = portfolioCharacteristics?.[0]?.portfolio_date;
  return (
    <Grid container direction="column" spacing={2} className={styles.container}>
      {type === '1' && (
        <>
          <Grid item>
            <SlideSubtitle>Portfolio Characteristics</SlideSubtitle>
            <SlideParagraph>
              Based on portfolio allocations as of {portfolioDate}. Exposures,
              fees, and yield may change over time, dependent on investment
              decisions made by strategists and investment managers. Platform
              fees and expense ratios are stated in basis points and as of{' '}
              {portfolioDate}. Equity exposure, yield, high yield, and emerging
              markets bond (EM) exposures are as of {portfolioDate}. Equity
              exposure, yield, high yield, and emerging markets bond (EM)
              exposures are as of 3/31/2024.
            </SlideParagraph>
            <SlideParagraph>
              *Based on stated maximum fees, may be lower based on any advisor
              exceptions.{' '}
            </SlideParagraph>
          </Grid>
        </>
      )}
      <Grid item>
        <ModelSetCharacteristicTable
          data={portfolioCharacteristics}
          template={type === '1' ? PORTFOLIO1 : PORTFOLIO2}
          fontSize={11}
        />
      </Grid>
    </Grid>
  );
}
